import React from 'react'

// components
import {
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import FormCheckboxInput from './FormCheckboxInput'

const FormInvoiceFormat = ({
  id,
  type,
  colSize,
  className,
  inputLabel,
  value,
  handleCheck,
  disabled
}) => {
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel>
          {inputLabel} : 
        </CFormLabel>
      )}
      <FormCheckboxInput 
        id={'is_soft_copy'}
        name={'is_soft_copy'}
        type={type}
        label='Soft Copy'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value.is_soft_copy}
      />
      <FormCheckboxInput 
        id={'is_hard_copy'}
        name={'is_hard_copy'}
        type={type}
        label='Hard Copy'
        handleCheck={handleCheck}
        disabled={disabled}
        value={value.is_hard_copy}
      />
    </CCol>
  )
}

export default FormInvoiceFormat